import { RigidBody } from '@react-three/rapier';
import { useRef, useEffect } from 'react';
import * as THREE from 'three';

export default function Block({ object, position, rotation, sound, color, onBlockClick }) {
    //Blocks will cast shadow by traversing each child
    useEffect(() => {
        object.traverse((child) => {
        if (child.isMesh) {
            child.castShadow = true;
            child.receiveShadow = true;
            // Optional: tweak material if it’s too glossy
            child.material.side = THREE.FrontSide;
        }
        });
    }, [object]);

    const bodyRef = useRef();

    const handlePointerDown = () => {
        if (bodyRef.current) {
            const body = bodyRef.current;

            // Wake up the body to ensure it doesn't sleep after a few clicks
            body.wakeUp();

            // Apply a random impulse and torque
            const impulse = {
                x: (Math.random() * 2 - 1) * 6,
                y: (Math.random() * 2 - 1) * 6,
                z: (Math.random() * 2 - 1) * 5
            };

            const torque = {
                x: (Math.random() * 2 - 1) * 5,
                y: (Math.random() * 2 - 1) * 6,
                z: (Math.random() * 2 - 1) * 6
            };

            body.applyImpulse(impulse);
            body.applyTorqueImpulse(torque);

            const soundFile = new Audio(sound);
            soundFile.play();
        }

        // Call onBlockClick with the color of the block
        if (onBlockClick) {
            onBlockClick(color);
        }
    };

    return (
        <RigidBody
            ref={bodyRef}
            type="dynamic"
            position={position}
            rotation={rotation}
            onPointerDown={handlePointerDown}
        >
            <primitive object={object} scale={0.35} castShadow receiveShadow />
        </RigidBody>
    );
}
